import { useCallback } from "react";

export function useAutoplayVideoInViewport() {
  return useCallback((node: HTMLVideoElement) => {
    if (!node) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            void node.play();
          } else {
            node.pause();
          }
        });
      },
      {
        threshold: 0.1,
      },
    );

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, []);
}
